var adjustedIds = {
  'ACCOUNT_SUMMARY_REACT': 'ACCOUNT_SUMMARY'
};
export default function adjustLinkId(navigationId) {
  /*
      While transitioning to full NAVBAR implementation
      backend needs to send a unique identifier for React
      environments so we need to adjust the ID to allow
      existing code to deal the menu link properly in
      src/components/page/navigation/mobile/NavigationMenuItemsList.js
    */
  return adjustedIds[navigationId] || navigationId;
}